import * as React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableSortLabel } from '@material-ui/core';
import { toggleSortDirection } from '../../youwell-common/tableUtils';
import { sortDirection } from '../../youwell-common/constants';

class SortableTableCell extends React.Component {
    onSortClick = () => {
        const { columnName, sorting, dataType } = this.props;

        if (sorting && sorting.columnName === columnName) {
            this.props.onSort({ columnName, direction: toggleSortDirection(sorting.direction), dataType });
        } else {
            this.props.onSort({ columnName, direction: sortDirection.asc, dataType });
        }
    }

    render() {
        const {
            className, label, columnName, sorting,
        } = this.props;

        return (
            <TableCell className={className}>
                <TableSortLabel
                    onClick={this.onSortClick}
                    active={sorting && sorting.columnName === columnName}
                    direction={sorting ? sorting.direction : undefined}
                >
                    {label}
                </TableSortLabel>
            </TableCell>
        );
    }
}

SortableTableCell.propTypes = {
    className: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    columnName: PropTypes.string.isRequired,
    dataType: PropTypes.string,
    onSort: PropTypes.func.isRequired,
    sorting: PropTypes.object,
};

SortableTableCell.defaultProps = {
    sorting: null,
    dataType: null,
};

export default SortableTableCell;
